import { useEffect, useState } from "react";
import api, { apiError } from "../../lib/api";
import { toast } from "sonner";

const CATEGORY_LABELS = { subscription: "Subscription", tax: "Tax", report: "Report", memo: "Memo", distribution: "Distribution advice", statement: "Statement", other: "Other" };

export default function Documents() {
  const [docs, setDocs] = useState(null);

  useEffect(() => {
    api.get("/documents").then((r) => setDocs(r.data)).catch(() => setDocs([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const download = async (doc) => {
    try {
      const res = await api.get(`/documents/${doc.document_id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = doc.original_filename;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  if (!docs) return <span className="t-label">Loading</span>;

  return (
    <div className="rise" data-testid="documents-page">
      <span className="t-label">Documents</span>
      <h1 className="t-h1 text-bone mt-3">Your documents</h1>
      <p className="t-small text-muted-s mt-2 measure">
        Subscription documents, tax schedules and member reports. Each file is issued to you and
        is not transferable.
      </p>

      <table className="table-solera mt-10" data-testid="documents-table">
        <thead>
          <tr><th>Document</th><th>Category</th><th>Date</th><th className="num">Size</th><th></th></tr>
        </thead>
        <tbody>
          {docs.map((d) => (
            <tr key={d.document_id} data-testid={`document-row-${d.document_id}`}>
              <td className="text-bone">{d.title}</td>
              <td className="text-muted-s">{CATEGORY_LABELS[d.category] || d.category}</td>
              <td className="text-muted-s t-small fig">{new Date(d.created_at).toISOString().slice(0, 10)}</td>
              <td className="num text-muted-s t-small">{(d.size / 1024).toFixed(1)} KB</td>
              <td className="text-right">
                <button onClick={() => download(d)} className="t-label hover:!text-[#E8E6E1] transition-colors duration-150"
                  data-testid={`download-button-${d.document_id}`}>Download</button>
              </td>
            </tr>
          ))}
          {docs.length === 0 && (
            <tr><td colSpan={5} className="text-muted-s t-small py-8">No documents issued yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
